<template>
  <div>
  <SimpleDataTable
      :title="title"
      :description="''"
      :dataList="salespersonSalePaymentData"
      :dataHeaders="salespersonSalePaymentHeaders"
      :loading="salespersonSalePaymentDataLoading"
      :per-page="salespersonSalePaymentData.length"
  >
    <template v-slot:filterAndAction>

      <v-select
          v-model="timePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="max-width:250px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="timePeriodFilterValue !== 5  ? _fetchSalesPersonSalePaymentList : null"
      >

      </v-select>
      <div v-if="timePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="dateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeStartFilterValue"
              locale="tr"
              :max="dateRangeEndFilterValue ? dateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="dateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeEndFilterValue"
              locale="tr"
              :min="dateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchSalesPersonSalePaymentList"
          >
            FİLTRELE
          </v-btn>
        </div>

      </div>

    </template>
    <template v-slot:tableFooter>
      <tr>
        <td><b>Toplam</b></td>
        <td><b>Tüm Plasiyerler</b></td>
        <td class="text-right">
          <b>{{ numberConverter(salesAmountSum) }}</b>
        </td>
        <td class="text-right">
          <b>{{ numberConverter(paymentAmountSum) }}</b>
        </td>
        <td class="text-right">
          <b>{{ numberConverter(cashPaymentSum) }}</b>
        </td>
        <td class="text-right">
          <b>{{ numberConverter(chequePaymentSum) }}</b>
        </td>
        <td class="text-right">
          <b>{{ numberConverter(receiptPaymentSum) }}</b>
        </td>
      </tr>
    </template>
  </SimpleDataTable>
  </div>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../helpers";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "PlasiyerTahsilatAnaliz",
  components: {
    SimpleDataTable
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchSalesPersonSalePaymentList()
  },
  data() {
    return {
      salespersonSalePaymentHeaders: [],
      salespersonSalePaymentData: [],
      salespersonSalePaymentDataLoading: false,
      timePeriodFilterValue: 4,
      dateRangeStartFilterValue: null,
      dateRangeEndFilterValue: null,
      salesAmountSum: null,
      paymentAmountSum: null,
      cashPaymentSum: null,
      chequePaymentSum: null,
      receiptPaymentSum: null,
    }
  },
  methods: {
    ...mapActions("dashboard", ["fetchSalesPersonSalePaymentList"]),
    ...mapMutations("dashboard",["setSalespersonSalePaymentData","setSalespersonSalePaymentDataLoading"]),
    formattedDate,
    numberConverter,
    _fetchSalesPersonSalePaymentList() {

      this.salespersonSalePaymentDataLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.timePeriodFilterValue === "" || this.timePeriodFilterValue == null)) && {DateType: this.timePeriodFilterValue},
        }
      };

      if (this.timePeriodFilterValue === 5) {
        requestData.body.startDate = this.dateRangeStartFilterValue;
        requestData.body.endDate = this.dateRangeEndFilterValue;
      }

      this.fetchSalesPersonSalePaymentList(requestData).then((result) => {
        const originalData = [...result.data.data];
        const copyForTable = JSON.parse(JSON.stringify(originalData));
        const copyForChart = JSON.parse(JSON.stringify(originalData));
        if (result && result.data.success) {
          this.salespersonSalePaymentData = copyForTable;

          this.salesAmountSum = copyForTable.map((item) => item.salesAmount).reduce((prev, curr) => prev + curr)
          this.paymentAmountSum = copyForTable.map((item) => item.paymentAmount).reduce((prev, curr) => prev + curr)
          this.cashPaymentSum = copyForTable.map((item) => item.cashPayment).reduce((prev, curr) => prev + curr)
          this.chequePaymentSum = copyForTable.map((item) => item.chequePayment).reduce((prev, curr) => prev + curr)
          this.receiptPaymentSum = copyForTable.map((item) => item.receiptPayment).reduce((prev, curr) => prev + curr)

          copyForTable.forEach((elem) => {
            elem.salesAmount = this.numberConverter(elem.salesAmount);
            elem.paymentAmount = this.numberConverter(elem.paymentAmount);
            elem.cashPayment = this.numberConverter(elem.cashPayment);
            elem.chequePayment = this.numberConverter(elem.chequePayment);
            elem.receiptPayment = this.numberConverter(elem.receiptPayment);
          });
          this.salespersonSalePaymentHeaders = [
            {
              key: 'salesPersonCode',
              label: 'Plasiyer Kodu',
              sortable: false,
            },
            {
              key: 'salesPersonName',
              label: 'Plasiyer Adı',
              sortable: false,
            },
            {
              key: 'salesAmount',
              label: 'KDV Dahil Satış Tutarı (TL)',
              class: 'text-right',
              sortable: false,
            },
            {
              key: 'paymentAmount',
              label: 'Toplam Tahsilat Tutarı',
              class: 'text-right',
              sortable: false,
            },
            {
              key: 'cashPayment',
              label: 'Nakit Tahsilat Tutarı',
              class: 'text-right',
              sortable: false,
            },
            {
              key: 'chequePayment',
              label: 'Çek Tahsilat Tutarı',
              class: 'text-right',
              sortable: false,
            },
            {
              key: 'receiptPayment',
              label: 'Dekont Tahsilat Tutarı',
              class: 'text-right',
              sortable: false,
            }

          ]
        } else
          this.salespersonSalePaymentData = [];

        this.salespersonSalePaymentDataLoading = false;
        this.setSalespersonSalePaymentData(copyForChart);
        this.setSalespersonSalePaymentDataLoading(false);
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchSalesPersonSalePaymentList()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchSalesPersonSalePaymentList()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchSalesPersonSalePaymentList()
    },
    timePeriodFilterValue(newVal) {
      newVal;
      if (newVal === 5) return;
      this._fetchSalesPersonSalePaymentList()
    },
  }
}
</script>

<style scoped>

</style>